import React from "react";
import './Alert.scss';

type AlertProps = {
    children: React.ReactNode,
    className?: string,
    color?: 'primary'|'red'|'yellow'|'green'|'gray',
};

function Alert(props: AlertProps) {

    return (
        <div className={`alert alert-${props.color ?? 'primary'} ${props.className}`}>{props.children}</div>
    );
}

export default Alert;
